<template>
  <div class="c-m-20">
    <div
      v-for="(v, i) in sonDatas"
      :key="i"
      class="c-bg-white c-m-b-20 item c-b-r-20"
    >
      <div class="c-p-20">
        <div class="c-fl-bt top-line-box">
          <div>{{ (v.EventType && v.EventType.Name) || "在线购买" }}</div>
          <div class="c-fl-bt delete-box" @click="deleteList">
            <div>{{ v.Status.Name }}</div>
            <!-- <g-img
              :src="require('@/assets/images/clearCar.png')"
              :size="25"
              color="#888"
            ></g-img> -->
          </div>
        </div>
        <div class="c-fl content" @click="toOrderDetail(v.Id, v.Status.Id)">
          <div class="l">
            <img
              :src="v.Details[0] && v.Details[0].ProductImageUrl"
              alt=""
              srcset=""
              class="l-img"
            />
          </div>

          <div class="r">
            <div class="r-box">
              <div class="c-fl-bt r-top">
                <div>{{ v.Details[0] && v.Details[0].ProductName }}</div>
              </div>
              <div>
                <!-- <div v-for="detail in v.Details" :key="detail.Id">
                  {{ detail.ProductName }} <i class="c-font-14">X</i>
                  <i class="c-p-r-20">{{ detail.Quantity }}</i
                  ><i> 单价: </i
                  ><i class="c-p-r-20">{{ detail.Price }}</i> 合计:
                  <i class="c-font-14">￥</i>{{ v.OrigMoney }}
                </div> -->

                <div>下单时间: {{ v.CreateTime }}</div>
                <div class="m-t-10">
                  订单编号: {{ v.Details[0] && v.Details[0].OrderId }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-bt m-t-20">
          <div class="">
            <van-button
              v-if="v.Status.Id == 1"
              type="info"
              plain
              color="var(--tc)"
              size="mini"
              round
              @click="lookCode(v)"
              >查看消费码</van-button
            >
          </div>
          <div class="goods-box">
            <div>
              合计：<i class="c-yang c-tc">￥</i>
              <span class="money c-tc">{{ aa(v.Details, "money") }}</span>
            </div>
            <div class="total-box">
              共<b>{{ aa(v.Details, "quantity") }}</b
              >件商品
            </div>
          </div>
        </div>
      </div>
      <g-line></g-line>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderListComp",
  props: {
    faImg: {
      type: String,
      default: "",
    },
    datas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sonDatas: this.datas,
    };
  },
  watch: {
    datas(val) {
      this.sonDatas = val;
    },
  },
  created() {},
  mounted() {},
  methods: {
    toDetail() {
      console.log("toDetail");
    },
    aa(v, which) {
      let Quantity = 0;
      let SettlePrice = 0;
      v.forEach((v) => {
        Quantity += v.Quantity;
        SettlePrice = this.$calc.add(
          SettlePrice,
          this.$calc.multiply(v.Quantity, v.Price)
        );
      });
      if (which === "money") {
        return SettlePrice;
      } else if (which === "quantity") {
        return Quantity;
      }
    },
    lookCode(v) {
      this.$router.push({
        name: "ConsumeCode",
        params: { id: v.Id },
      });
    },
    toOrderDetail(orderId) {
      this.$router.push({
        path: "/goods/orderDetail",
        query: { id: orderId },
      });
    },
    deleteList() {
      this.$dialog
        .confirm({
          title: "删除",
          message: "确定要删除当前订单吗",
        })
        .then(() => {
          // on confirm
          // this.$parent.init();
          this.$emit("delete");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  /* height: 200px; */
  .f {
    flex: 1;
  }
  .l-img {
    width: 130px;
    height: 130px;
    border-radius: 10px;
  }
  .r {
    flex: 2;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }
  .r-top {
    .main-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .sub-title {
      font-size: 22px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      margin-top: 20px;
    }
  }
  .r-bottom {
    .change-color {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--tc);
      margin-right: 10px;
    }
    .origin-color {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      text-decoration: line-through;
    }
  }
}
.top-line-box {
  font-size: 28px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  align-items: flex-end;
  .delete-box {
    // width: 120px;
    font-size: 28px;
    align-items: center;
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #888888;
  }
}

.r-box {
  margin: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  font-size: 20px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #888888;
  height: 150px;
  box-sizing: border-box;
  .x-num {
    position: relative;
    top: -20px;
    text-align: right;
  }
  .r-top {
    font-size: 30px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #333333;
  }
  .order-num {
    margin-bottom: 10px;
  }
}
.goods-box {
  display: flex;
  flex-direction: row-reverse;
  align-items: baseline;
  // margin-top: 20px;
  height: 44px;
  line-height: 44px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  box-sizing: border-box;
  b {
    font-weight: unset;
  }
  i {
    font-style: unset;
    padding-left: 10px;
  }
  .total-box {
    padding-right: 10px;
  }
  .money {
    font-size: 32px;
  }
}
</style>
